export default __webpack_public_path__ + "static/media/015-hospital.dc39a2e0.svg";